import  gql  from 'graphql-tag'

export const CREATE_COMMISSION = gql`mutation commission($input: CommissionMutationInput!){
    commission(input: $input){
        commission{
            id
            data
        }
        errors{
            field
            messages
        }
    }
}`;